module.exports = __webpack_public_path__ + "img/coach2.8e9a1261.png";